<div class="d-flex">
    <span class="d-none d-sm-inline zci-text--bold">
        {{ navOverflowMenuConfig.label }}
    </span>
    <c11n-nav-overflow
        [ariaLabelId]="navOverflowMenuConfig.labelId"
        [menuData]="navOverflowMenuConfig.data"
        data-cy="actions-nav-overflow-menu"></c11n-nav-overflow>
</div>
